import { css } from '@emotion/react';

export default css`
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 100;
    src: local('Overpass Thin Italic'), local('Overpass-ThinItalic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdD35WCmI96Ajtm81Gga7rayz8NoVgyNIjK.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 100;
    src: local('Overpass Thin Italic'), local('Overpass-ThinItalic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdD35WCmI96Ajtm81Gga7raxT8NoVgyNA.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 200;
    src: local('Overpass ExtraLight Italic'), local('Overpass-ExtraLightItalic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81GgaxbL0hYojnA4PLDzOA.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 200;
    src: local('Overpass ExtraLight Italic'), local('Overpass-ExtraLightItalic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81GgaxbL0hgojnA4PLA.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 300;
    src: local('Overpass Light Italic'), local('Overpass-LightItalic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81Gga3LI0hYojnA4PLDzOA.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 300;
    src: local('Overpass Light Italic'), local('Overpass-LightItalic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81Gga3LI0hgojnA4PLA.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 400;
    src: local('Overpass Italic'), local('Overpass-Italic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdB35WCmI96Ajtm81GgY9fqxzUKg1oCNQ.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 400;
    src: local('Overpass Italic'), local('Overpass-Italic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdB35WCmI96Ajtm81GgY9nqxzUKg1o.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 600;
    src: local('Overpass SemiBold Italic'), local('Overpass-SemiBoldItalic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81GgawbO0hYojnA4PLDzOA.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 600;
    src: local('Overpass SemiBold Italic'), local('Overpass-SemiBoldItalic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81GgawbO0hgojnA4PLA.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 700;
    src: local('Overpass Bold Italic'), local('Overpass-BoldItalic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81Gga2LP0hYojnA4PLDzOA.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 700;
    src: local('Overpass Bold Italic'), local('Overpass-BoldItalic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81Gga2LP0hgojnA4PLA.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 800;
    src: local('Overpass ExtraBold Italic'), local('Overpass-ExtraBoldItalic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81Gga37M0hYojnA4PLDzOA.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 800;
    src: local('Overpass ExtraBold Italic'), local('Overpass-ExtraBoldItalic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81Gga37M0hgojnA4PLA.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 900;
    src: local('Overpass Black Italic'), local('Overpass-BlackItalic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81Gga1rN0hYojnA4PLDzOA.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: italic;
    font-weight: 900;
    src: local('Overpass Black Italic'), local('Overpass-BlackItalic'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdC35WCmI96Ajtm81Gga1rN0hgojnA4PLA.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 100;
    src: local('Overpass Thin'), local('Overpass-Thin'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdB35WCmI96Ajtm81nGY9fqxzUKg1oCNQ.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 100;
    src: local('Overpass Thin'), local('Overpass-Thin'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdB35WCmI96Ajtm81nGY9nqxzUKg1o.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 200;
    src: local('Overpass ExtraLight'), local('Overpass-ExtraLight'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81lqcs7D4hoiiVI6DLE.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 200;
    src: local('Overpass ExtraLight'), local('Overpass-ExtraLight'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81lqcs7N4hoiiVI6.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 300;
    src: local('Overpass Light'), local('Overpass-Light'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81kOcc7D4hoiiVI6DLE.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 300;
    src: local('Overpass Light'), local('Overpass-Light'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81kOcc7N4hoiiVI6.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 400;
    src: local('Overpass Regular'), local('Overpass-Regular'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdH35WCmI96Ajtm81GrU9vgwBcIs1s.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 400;
    src: local('Overpass Regular'), local('Overpass-Regular'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdH35WCmI96Ajtm81GlU9vgwBcI.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 600;
    src: local('Overpass SemiBold'), local('Overpass-SemiBold'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81l6d87D4hoiiVI6DLE.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 600;
    src: local('Overpass SemiBold'), local('Overpass-SemiBold'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81l6d87N4hoiiVI6.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 700;
    src: local('Overpass Bold'), local('Overpass-Bold'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81keds7D4hoiiVI6DLE.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 700;
    src: local('Overpass Bold'), local('Overpass-Bold'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81keds7N4hoiiVI6.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 800;
    src: local('Overpass ExtraBold'), local('Overpass-ExtraBold'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81kCdc7D4hoiiVI6DLE.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 800;
    src: local('Overpass ExtraBold'), local('Overpass-ExtraBold'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81kCdc7N4hoiiVI6.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 900;
    src: local('Overpass Black'), local('Overpass-Black'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81kmdM7D4hoiiVI6DLE.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass';
    font-style: normal;
    font-weight: 900;
    src: local('Overpass Black'), local('Overpass-Black'),
      url(https://fonts.gstatic.com/s/overpass/v4/qFdA35WCmI96Ajtm81kmdM7N4hoiiVI6.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass Mono';
    font-style: normal;
    font-weight: 300;
    src: local('Overpass Mono Light'), local('OverpassMono-Light'),
      url(https://fonts.gstatic.com/s/overpassmono/v5/_Xm3-H86tzKDdAPa-KPQZ-AC3oSWo_6XBlRc4EUk4A.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass Mono';
    font-style: normal;
    font-weight: 300;
    src: local('Overpass Mono Light'), local('OverpassMono-Light'),
      url(https://fonts.gstatic.com/s/overpassmono/v5/_Xm3-H86tzKDdAPa-KPQZ-AC3oSWo_CXBlRc4EU.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass Mono';
    font-style: normal;
    font-weight: 400;
    src: local('Overpass Mono Regular'), local('OverpassMono-Regular'),
      url(https://fonts.gstatic.com/s/overpassmono/v5/_Xmq-H86tzKDdAPa-KPQZ-AC1iG0tt21C35m6Q.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass Mono';
    font-style: normal;
    font-weight: 400;
    src: local('Overpass Mono Regular'), local('OverpassMono-Regular'),
      url(https://fonts.gstatic.com/s/overpassmono/v5/_Xmq-H86tzKDdAPa-KPQZ-AC1i-0tt21C34.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass Mono';
    font-style: normal;
    font-weight: 600;
    src: local('Overpass Mono SemiBold'), local('OverpassMono-SemiBold'),
      url(https://fonts.gstatic.com/s/overpassmono/v5/_Xm3-H86tzKDdAPa-KPQZ-AC3vCQo_6XBlRc4EUk4A.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass Mono';
    font-style: normal;
    font-weight: 600;
    src: local('Overpass Mono SemiBold'), local('OverpassMono-SemiBold'),
      url(https://fonts.gstatic.com/s/overpassmono/v5/_Xm3-H86tzKDdAPa-KPQZ-AC3vCQo_CXBlRc4EU.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }
  /* latin-ext */
  @font-face {
    font-family: 'Overpass Mono';
    font-style: normal;
    font-weight: 700;
    src: local('Overpass Mono Bold'), local('OverpassMono-Bold'),
      url(https://fonts.gstatic.com/s/overpassmono/v5/_Xm3-H86tzKDdAPa-KPQZ-AC3pSRo_6XBlRc4EUk4A.woff2)
        format('woff2');
    unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
      U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
  }
  /* latin */
  @font-face {
    font-family: 'Overpass Mono';
    font-style: normal;
    font-weight: 700;
    src: local('Overpass Mono Bold'), local('OverpassMono-Bold'),
      url(https://fonts.gstatic.com/s/overpassmono/v5/_Xm3-H86tzKDdAPa-KPQZ-AC3pSRo_CXBlRc4EU.woff2)
        format('woff2');
    unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
      U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212,
      U+2215, U+FEFF, U+FFFD;
  }

  @font-face {
    font-family: 'Termina';
    src: local('Termina'),
      url(/fonts/termina/Termina-Regular.otf) format('opentype');
  }

  @font-face {
    font-family: 'Termina';
    src: local('Termina'),
      url(/fonts/termina/Termina-Bold.otf) format('opentype');
    font-weight: 700;
  }

  @font-face {
    font-family: 'Termina';
    src: local('Termina'),
      url(/fonts/termina/Termina-Heavy.otf) format('opentype');
    font-weight: 800;
    font-family: 'Acumin Pro';
    src: local('Acumin Pro'),
      url(/fonts/acumin-pro/AcuminPro-Regular.otf) format('opentype');
  }

  @font-face {
    font-family: 'Acumin Pro';
    src: local('Acumin Pro'),
      url(/fonts/acumin-pro/AcuminPro-Italic.otf) format('opentype');
    font-style: italic;
  }

  @font-face {
    font-family: 'Acumin Pro';
    src: local('Acumin Pro'),
      url(/fonts/acumin-pro/AcuminPro-Medium.otf) format('opentype');
    font-weight: 500;
  }

  @font-face {
    font-family: 'Acumin Pro';
    src: local('Acumin Pro'),
      url(/fonts/acumin-pro/AcuminPro-MediumItalic.otf) format('opentype');
    font-weight: 500;
    font-style: italic;
  }

  @font-face {
    font-family: 'Acumin Pro';
    src: local('Acumin Pro'),
      url(/fonts/acumin-pro/AcuminPro-SemiBold.otf) format('opentype');
    font-weight: 600;
  }

  @font-face {
    font-family: 'Acumin Pro';
    src: local('Acumin Pro'),
      url(/fonts/acumin-pro/AcuminPro-SemiBoldItalic.otf) format('opentype');
    font-weight: 600;
    font-style: italic;
  }

  @font-face {
    font-family: 'Acumin Pro';
    src: local('Acumin Pro'),
      url(/fonts/acumin-pro/AcuminPro-Bold.otf) format('opentype');
    font-weight: 700;
  }

  @font-face {
    font-family: 'IBM Plex Mono';
    src: local('IBM Plex Mono'),
      url(/fonts/ibm-plex/IBMPlexMono-Regular.ttf) format('truetype');
  }

  * {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    font-family: 'Overpass', sans-serif;
  }

  #root {
    height: 100vh;
    width: 100vw;
  }

  /* applies to the markdown editor button text */
  button i::before {
    font-style: normal;
  }

  button,
  button:focus {
    outline: 0;
  }
  button:hover {
    cursor: pointer;
  }

  .avatar #Circle > g {
    fill: #e5e5e5;
  }

  @keyframes animatebg {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: 300% 0;
    }
  }
`;
